import axios from "axios";
import store from "../store";
import router from "../router";

export class APIService {
  api(config) {
    return axios(config)
      .then(response => response.data)
      .catch(e => {
        console.log("got here");
        return this.error(e);
      });
  }

  error(e) {
    console.log(e);
    if (e.response.data.message) {
      if (e.response.data.message === "Token is invalid!") {
        store.dispatch("resetState");
        router.push("/console/login");
      } else if (e.response.data.message === "Could not find property") {
        console.log("could not find property");
        router.push("/console/unauthorized");
      }
      return Promise.reject(e.response.data.message);
    } else {
      return Promise.reject(Error("Unable to connect to server"));
    }
  }
}
